import React from 'react';

interface DotGridProps {
  rows: number;
  columns: number;
  dotColor?: string;
  backgroundColor?: string;
  gridWidth?: string;
  gridHeight?: string;
  dotSize?: string;
}

export const DotGrid: React.FC<DotGridProps> = ({
  rows,
  columns,
  dotColor = 'black',
  backgroundColor = 'transparent',
  gridWidth = '100%',
  gridHeight = '100%',
  dotSize = '.5px',
}) => {
  const gridStyle = {
    display: 'grid',
    gridTemplateRows: `repeat(${rows}, 1fr)`,
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    width: gridWidth,
    height: gridHeight,
    backgroundColor,
    justifyItems: 'center',
    alignItems: 'center',
  };

  const dotStyle = {
    width: dotSize,
    height: dotSize,
    borderRadius: '50%',
    backgroundColor: dotColor,
  };

  return (
    <div style={gridStyle} className="gap-[1px]">
      {Array.from({ length: rows * columns }).map((_, index) => (
        <div key={index} style={dotStyle} />
      ))}
    </div>
  );
};
